module.exports = __webpack_public_path__ + "static/img/11.82c6974.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/11.png
// module id = /dAE
// module chunks = 0